export const CACHE_KEY_SYNC_CRM_INTERESTS = 'sync-crm-interests';
export const CACHE_KEY_SYNC_CRM_PRODUCTS = 'sync-crm-products';
